import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import nl from "./locales/nl.json";

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, nl: { translation: nl } },
  lng: typeof localStorage === "undefined" ? "nl" : (localStorage.getItem("peer-start-language") ?? "nl"),
  fallbackLng: "nl",
  interpolation: { escapeValue: false },
});

export const supportedLanguages = ["nl", "en"] as const;
export default i18n;
